export const isMobileOrTablet = (): boolean => {
  const nav = navigator as Navigator & {
    userAgentData?: {
      mobile?: boolean;
      platform?: string;
    };
  };

  // Prefer User-Agent Client Hints when available.
  if (nav.userAgentData?.mobile) return true;

  const ua = nav.userAgent || navigator.userAgent;
  if (/Android|iPhone/i.test(ua)) return true;
  if (/iPad/i.test(ua)) return true;

  // iPadOS 13+ may report itself as macOS while supporting touch.
  if (nav.userAgentData?.platform === 'macOS' && navigator.maxTouchPoints > 1) return true;

  // Legacy fallback: navigator.platform is deprecated and may be frozen.
  // Kept only as a best-effort heuristic for environments without userAgentData.
  const legacyPlatform = (navigator as Navigator & { platform?: string }).platform;
  if (legacyPlatform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
  return false;
};
